<template>
    <section class="fleet-setup-activate mb-2">
        <div class="setup-activation-card">
            <!-- LEFT SIDE -->
            <div class="setup-promo">
                <div class="offer-badge"><icon name="faGift" type="solid"></icon><span>SPECIAL OFFER</span></div>
                <h2>Activate Your Fleet Account</h2>
                <h3>Get 3 Months Free!</h3>
                <p class="promo-copy">Complete your setup by adding your billing address and unlock 3 months of fleet features free.</p>
                <div class="promo-image">
                    <img title="Promo Image" src="/accounts/img/promo.png" width="350" height="auto" />
                </div>
            </div>

            <!-- RIGHT SIDE -->
            <div class="setup-form-side">
                <div class="benefits-grid">
                    <div class="benefit-item">
                        <icon name="faUsers" type="solid"></icon>
                        <span>Unlimited team access</span>
                    </div>

                    <div class="benefit-item">
                        <icon name="faStar" type="solid"> </icon>
                        <span>Shared vendor notes & ratings</span>
                    </div>

                    <div class="benefit-item">
                        <icon name="faShareNodes" type="solid"></icon>
                        <span>Fleet-wide dealer management</span>
                    </div>

                    <div class="benefit-item">
                        <icon name="faShield" type="solid"></icon>
                        <span>Favorite and Avoided vendor management</span>
                    </div>

                    <div class="benefit-item">
                        <icon name="faShield" type="solid"></icon>
                        <span>Access to 40,000+ vendors - all services</span>
                    </div>
                </div>

                <div class="form-divider"></div>
                <div class="form">
                    <div v-if="isLoading" class="loading">
                        <icon name="faSpinner" type="solid" spin></icon>
                    </div>
                    <div class="td-banner danger dismissible my-2" v-if="errorMessage">
                        <icon name="faCircleExclamation" type="solid"></icon>
                        <p>{{ errorMessage }}</p>
                        <icon name="faXmark" type="solid" @click="errorMessage = undefined"></icon>
                    </div>
                    <div class="pb-1">
                        <label class="td-label">Address Line 1:</label>
                        <input :class="[{'error': addressValidator.errors['line1']}, 'td-input']"
                               v-model="address.line1" type="text" placeholder="Address Line 1"
                               @input="addressValidator.validate('line1');" :disabled="isLoading" />
                        <error v-if="addressValidator.errors['line1']" :error="addressValidator.errors['line1']"></error>
                    </div>
                    <div class="pb-1">
                        <label class="td-label">Address Line 2:</label>
                        <input class="td-input" v-model="address.line2" type="text" placeholder="Suite, Floor, Building, etc." :disabled="isLoading" />
                    </div>
                    <div class="pb-1">
                        <label class="td-label">City:</label>
                        <input :class="[{'error': addressValidator.errors['city']}, 'td-input']"
                               v-model="address.city" type="text" placeholder="City" @input="addressValidator.validate('city')" :disabled="isLoading" />
                        <error v-if="addressValidator.errors['city']" :error="addressValidator.errors['city']"></error>
                    </div>
                    <div class="sm-col-2 pb-1">
                        <div>
                            <label class="td-label">Country:</label>
                            <select v-model="address.countryCode" id="countryCode" name="countryCode" required
                                    :class="[{'error': addressValidator.errors['countryCode']}, 'td-select']"
                                    @change="addressValidator.validate('countryCode')" placeholder="Select Country" :disabled="isLoading">
                                <option value="" disabled selected>Select country</option>
                                <option value="CA">Canada</option>
                                <option value="US">United States</option>
                            </select>
                            <error v-if="addressValidator.errors['countryCode']" :error="addressValidator.errors['countryCode']"></error>
                        </div>
                        <div>
                            <label class="td-label">State/Prov:</label>
                            <select v-model="address.regionCode" id="regionCode" name="regionCode" required
                                    :class="[{'error': addressValidator.errors['regionCode']}, 'td-select']"
                                    @change="addressValidator.validate('regionCode')" placeholder="Select State/Prov" :disabled="isLoading">
                                <option value="" disabled selected>Select region</option>
                                <option v-for="region in selectableRegions" :value="region.code" :key="region.code">{{ region.name }}</option>
                            </select>
                            <error v-if="addressValidator.errors['regionCode']" :error="addressValidator.errors['regionCode']"></error>
                        </div>
                    </div>
                    <div class="pb-1">
                        <label class="td-label">Postal/Zip Code:</label>
                        <input :class="[{'error': addressValidator.errors['postalCode']}, 'td-input']"
                               v-model="address.postalCode" type="text" placeholder="Postal/Zip Code"
                               @input="addressValidator.validate('postalCode')"
                               @blur="addressValidator.validate('postalCodeFinal')" :disabled="isLoading" />
                        <error v-if="addressValidator.errors['postalCode']" :error="addressValidator.errors['postalCode']"></error>
                        <error v-if="addressValidator.errors['postalCodeFinal']" :error="addressValidator.errors['postalCodeFinal']"></error>
                    </div>

                    <div class="trial-notice">
                        <icon name="faCircleCheck" type="solid"></icon>
                        <div>
                            <strong>Your free trial starts immediately after activation.</strong>
                            <p>No charges will apply during your 3-month trial period and there is no commitment for you to continue after your trial period.</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import script from './Activate';
    export default script;</script>

<style lang="less">
    @import "./Activate.less";
</style>